<template>
  <q-btn
    icon="fa fa-plus"
    label="Install"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { IntegrationConnection, IntegrationPreset } from '@/iam/types';
import InstallModal from './InstallModal.vue';

export default defineComponent({
  emits: ['installed'],
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    preset: {
      type: Object as () => IntegrationPreset,
      required: true,
    },
  },
  methods: {
    openModal(): void {
      const config = { parent: this, accountId: this.accountId, preset: this.preset };
      openModal(InstallModal, config).onOk((connection: IntegrationConnection) => {
        this.$emit('installed', connection);
      });
    },
  },
});
</script>
